import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';
import { SUBSCRIPTION_HEADER_NAME } from '../constants/constants';
import { saveFile } from '../helpers/saveFile';
import { API_ROOT } from '../helpers/apiConfig';

export const actions = {
	getSubscription: (id) => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'subscriptions/' + id,
				method: 'GET',
				types: [types.GET_SUBSCRIPTION_REQUEST, types.GET_SUBSCRIPTION_SUCCESS, types.GET_SUBSCRIPTION_FAILURE],
			},
		});
	},
	getSubscriptionFilters: (id) => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'subscriptions/index-filters',
				method: 'POST',
				body: { id: id },
				types: [types.GET_SUBSCRIPTION_FILTERS_REQUEST, types.GET_SUBSCRIPTION_FILTERS_SUCCESS, types.GET_SUBSCRIPTION_FILTERS_FAILURE],
			},
		});
	},
	getSubscriptionProfile: () => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'subscriptions/profile',
				method: 'GET',
				types: [types.GET_SUBSCRIPTION_PROFILE_REQUEST, types.GET_SUBSCRIPTION_PROFILE_SUCCESS, types.GET_SUBSCRIPTION_PROFILE_FAILURE],
			},
		});
	},
	listSubscriptions: () => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'subscriptions/list',
				method: 'GET',
				types: [types.LIST_SUBSCRIPTIONS_REQUEST, types.LIST_SUBSCRIPTIONS_SUCCESS, types.LIST_SUBSCRIPTIONS_FAILURE],
			},
		});
	},
	saveSubscription: (subscription, file) => (dispatch) => {
		let body = new FormData();
		body.append('file', file);

		for (let key in subscription) {
			if (key === 'faqs') {
				let faqs = JSON.stringify(subscription[key]);
				body.append(key, faqs);
			} else if (key === 'goalGroups') {
				let goalGroups = JSON.stringify(subscription[key]);
				body.append(key, goalGroups);
			} else {
				body.append(key, subscription[key]);
			}
		}

		if (subscription.id === 0) {
			// Create
			return dispatch({
				[CALL_API]: {
					endpoint: 'subscriptions/create',
					method: 'POST',
					body: body,
					types: [types.CREATE_SUBSCRIPTION_REQUEST, types.CREATE_SUBSCRIPTION_SUCCESS, types.CREATE_SUBSCRIPTION_FAILURE],
				},
			});
		} else {
			// Update
			return dispatch({
				[CALL_API]: {
					endpoint: 'subscriptions/update',
					method: 'PUT',
					body: body,
					types: [types.UPDATE_SUBSCRIPTION_REQUEST, types.UPDATE_SUBSCRIPTION_SUCCESS, types.UPDATE_SUBSCRIPTION_FAILURE],
				},
			});
		}
	},
	saveSubscriptionProfile: (subscription, file) => (dispatch) => {
		let body = new FormData();
		body.append('file', file);

		for (let key in subscription) {
			if (key === 'FAQs') {
				let faqs = JSON.stringify(subscription[key]);
				body.append('faQs', faqs);  // Backend expects camelCase 'faQs'
			} else if (key === 'goalGroups') {
				let goalGroups = JSON.stringify(subscription[key]);
				body.append(key, goalGroups);
			} else {
				body.append(key, subscription[key]);
			}
		}

		return dispatch({
			[CALL_API]: {
				endpoint: 'subscriptions/update-profile',
				method: 'PUT',
				body: body,
				types: [
					types.UPDATE_SUBSCRIPTION_PROFILE_REQUEST,
					types.UPDATE_SUBSCRIPTION_PROFILE_SUCCESS,
					types.UPDATE_SUBSCRIPTION_PROFILE_FAILURE,
				],
			},
		});
	},
	getInviteMessage: (subId) => (dispatch) => {
		const body = {
			subscriptionId: subId,
		};
		return dispatch({
			[CALL_API]: {
				endpoint: 'subscriptions/invite-message',
				method: 'POST',
				body: body,
				types: [
					types.GET_SUBSCRIPTION_INVITEMESSAGE_REQUEST,
					types.GET_SUBSCRIPTION_INVITEMESSAGE_SUCCESS,
					types.GET_SUBSCRIPTION_INVITEMESSAGE_FAILURE,
				],
			},
		});
	},
	getReportFooter: () => (dispatch) => {
		return dispatch({
			[CALL_API]: {
				endpoint: 'subscriptions/report-footer',
				method: 'GET',
				types: [
					types.GET_SUBSCRIPTION_REPORT_FOOTER_REQUEST,
					types.GET_SUBSCRIPTION_REPORT_FOOTER_SUCCESS,
					types.GET_SUBSCRIPTION_REPORT_FOOTER_FAILURE,
				],
			},
		});
	},
	importTemplate: () => {
		return (dispatch, getState) => {
			const endpoint = 'user/import-template';
			const method = 'GET';
			let headers = {};
			const token = getState().user.accessToken;
			if (typeof token === 'string') {
				headers.Authorization = `Bearer ${token}`;
			}
			const subscriptionId = getState().user.currentSubscriptionId;
			if (subscriptionId) {
				headers[SUBSCRIPTION_HEADER_NAME] = subscriptionId;
			}

			return (
				// eslint-disable-next-line no-undef
				fetch(`${API_ROOT}${endpoint}`, {
					method,
					headers,
					credentials: 'same-origin',
				})
					.then(async (response) => {
						await saveFile(response);
					})
					.catch((error) => {
						return error;
					})
			);
		};
	},
};
